import { render, staticRenderFns } from "./OsmMapPage.vue?vue&type=template&id=2e1084d5&scoped=true"
import script from "./OsmMapPage.vue?vue&type=script&lang=js"
export * from "./OsmMapPage.vue?vue&type=script&lang=js"
import style0 from "./OsmMapPage.vue?vue&type=style&index=0&id=2e1084d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1084d5",
  null
  
)

export default component.exports